import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "logs-view"
}
const _hoisted_2 = {
  key: 0,
  class: "row mt-2 justify-content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "row mt-2 justify-content-center"
}
const _hoisted_4 = {
  key: 2,
  class: "row mt-2 justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Статистика для методов", -1)
const _hoisted_6 = { class: "panel" }
const _hoisted_7 = { class: "row align-items-center" }
const _hoisted_8 = { class: "col-auto ml-auto" }
const _hoisted_9 = {
  key: 0,
  class: "row mt-2 justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_top_view_table = _resolveComponent("top-view-table")!
  const _component_tirscript3_table_header_item = _resolveComponent("tirscript3-table-header-item")!
  const _component_tirscript3_table_body_item = _resolveComponent("tirscript3-table-body-item")!
  const _component_tirscript3_table = _resolveComponent("tirscript3-table")!
  const _component_tirscript3_pagination = _resolveComponent("tirscript3-pagination")!

  return (_ctx.filter)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
        _createElementVNode("div", null, [
          _createVNode(_component_top_view_table, {
            items: _ctx.itemsTopReqTimeExtends,
            pages: _ctx.topReqTimeExtendsPage,
            title: "Топ долгих запросов (Максимальные по времени)",
            onChangePage: _ctx.onChangePageTopReqTime
          }, null, 8, ["items", "pages", "onChangePage"])
        ]),
        (!_ctx.error1.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error1.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_top_view_table, {
            items: _ctx.itemsTopReqVolumeExtends,
            pages: _ctx.itemsTopReqVolumeExtendsPage,
            title: "Топ больших запросов (Максимальные по объему)",
            onChangePage: _ctx.onChangePageTopReqValue
          }, null, 8, ["items", "pages", "onChangePage"])
        ]),
        (!_ctx.error2.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error2.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_top_view_table, {
            items: _ctx.itemsTopRespExtends,
            pages: _ctx.itemsTopRespExtendsPage,
            title: "Топ больших ответов (Максимальные по объему)",
            onChangePage: _ctx.onChangePageTopResp
          }, null, 8, ["items", "pages", "onChangePage"])
        ]),
        (!_ctx.error3.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error3.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_component_tirscript3_table, {
            items: _ctx.itemsStat,
            pages: _ctx.topReqTimeExtendsPage,
            style: {"overflow-x":"auto"},
            "template-columns": "auto auto auto auto auto auto auto auto"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Класс/Метод")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Количество вызовов ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Среднее время выполнения ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Общее время выполнения ms ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Средний объем запросов в байтах ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Общий объем запросов в байтах ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Средний объем ответов в байтах ")
                ]),
                _: 1
              }),
              _createVNode(_component_tirscript3_table_header_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("Общий объем ответов в байтах ")
                ]),
                _: 1
              })
            ]),
            body: _withCtx((data) => [
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.Class + ' / ' + data.item.Method), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.InvocationsCount), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.AverageExecutingTime), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.SummaryExecutingTime), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.AverageRequestsSize), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.SummaryRequestsLength), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.AverageResponsesSize), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_tirscript3_table_body_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.SummaryResponsesLength), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["items", "pages"]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_tirscript3_pagination, {
                  ref: "pagination",
                  count: _ctx.count,
                  size: _ctx.size,
                  class: "mt-4",
                  onOnChange: _ctx.onPaginationChanged
                }, null, 8, ["count", "size", "onOnChange"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.itemsStat && _ctx.itemsStat.length > 0]
          ]),
          (!_ctx.error4.isSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error4.errorMessage), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}